import { render, staticRenderFns } from "./dataHigh.vue?vue&type=template&id=7c0562b1&scoped=true&"
import script from "./dataHigh.vue?vue&type=script&lang=js&"
export * from "./dataHigh.vue?vue&type=script&lang=js&"
import style0 from "./dataHigh.vue?vue&type=style&index=0&id=7c0562b1&scoped=true&lang=css&"
import style1 from "./dataHigh.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0562b1",
  null
  
)

export default component.exports